import { render, staticRenderFns } from "./electron.vue?vue&type=template&id=1bbd0eb5&scoped=true"
import script from "./electron.vue?vue&type=script&lang=js"
export * from "./electron.vue?vue&type=script&lang=js"
import style0 from "./electron.vue?vue&type=style&index=0&id=1bbd0eb5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbd0eb5",
  null
  
)

export default component.exports